import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import React, { useState } from 'react'
import DocumentContent from '../../ModalCotent/RequiredDocument/DocumentContent'
import AddDocument from './AddDocument'
import { eventCommonStore } from 'state/event/eventCommon'

interface RequiredDocumentProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
  organizationId: string
  referenceId: string
  reference: 'event' | 'league' | 'organization'
  selectedRequiredDocumentIds: string[]
  setSelectedRequiredDocumentIds: (state: string[]) => void
}

const RequiredDocument: React.FC<RequiredDocumentProps> = ({
  openModal,
  closeModal,
  organizationId,
  referenceId,
  reference,
  selectedRequiredDocumentIds,
  setSelectedRequiredDocumentIds,
}) => {
  const { addDocument, setAddDocument } = eventCommonStore(store => ({
    addDocument: store.addDocument,
    setAddDocument: store.setAddDocument,
  }))

  const handleCancel = () => {
    closeModal(false)
  }

  const handleAddDocument = () => {
    setAddDocument(true)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom={true}
        closeModal={handleCancel}
        title="Required details"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Add Document,Save"
            btnType="primary"
            closeModal={handleAddDocument}
            onSubmit={handleCancel}
          />
        }
      >
        <p>
          Select mandatory documents that should be uploaded on registration of
          the league. You also can add any document you need.
        </p>
        <DocumentContent
          organizationId={organizationId}
          referenceId={referenceId}
          reference={reference}
          selectedRequiredDocumentIds={selectedRequiredDocumentIds}
          setSelectedRequiredDocumentIds={setSelectedRequiredDocumentIds}
        />
      </CustomModal>

      {addDocument && (
        <AddDocument
          openModal={addDocument}
          setOpenModal={setAddDocument}
          organizationId={organizationId}
          data={undefined}
        />
      )}
    </>
  )
}

export default RequiredDocument
